import {Component, inject, OnInit} from '@angular/core';
import {EmailPlayersButtonComponent} from "../../../components/email-players-button/email-players-button.component";
import {ContainerComponent} from "@coreui/angular";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {BroadcastNotificationService} from "../../../services/broadcast-notification.service";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatButton} from "@angular/material/button";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {RouterLink} from "@angular/router";
import {BroadcastNotificationsTableComponent} from "../../../components/broadcast-notifications-table/broadcast-notifications-table.component";
import {IBroadcastNotification} from "../../../interfaces/notifications/IBroadcastNotification";

@Component({
  selector: 'app-causable-admin-manage-notifications',
  standalone: true,
  imports: [
    EmailPlayersButtonComponent,
    ContainerComponent,
    MatProgressSpinner,
    MatButton,
    HasPermissionDirective,
    RouterLink,
    BroadcastNotificationsTableComponent
  ],
  templateUrl: './causable-admin-manage-notifications.component.html',
  styleUrl: './causable-admin-manage-notifications.component.css'
})
export class CausableAdminManageNotificationsComponent implements OnInit {
  public broadcastNotifications: IBroadcastNotification[] = [];
  public uiState: UIStateEnum = UIStateEnum.ShowLoading;
  public uiStateEnumForTemplate = UIStateEnum;
  public permissionTypes = PermissionTypes;

  private broadcastNotificationService = inject(BroadcastNotificationService);
  private errorHandlingService = inject(ErrorHandlingService);

  ngOnInit() {
    this.loadNotifications();
  }

  private loadNotifications() {
    this.uiState = UIStateEnum.ShowLoading;
    this.broadcastNotificationService.getAllBroadcastNotifications().subscribe({
      next: (notifications) => {
        this.broadcastNotifications = notifications;
        this.uiState = UIStateEnum.ShowData;
      },
      error: (err) => {
        // Clear first: displayPageLevelErrorMessage rethrows, so don't leave stale rows rendered.
        this.broadcastNotifications = [];
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }
}
